<template>
  <div class="container page">
    <van-nav-bar :title="$t('minex.personal_info')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
      <template #right>
        <div style="font-size: 14px;" @click="loginout">{{ $t("setting.logout") }}</div>
      </template>
    </van-nav-bar>
    <div style="height: 10px;background-color: transparent;"></div>
    <div class="items">
      <div class="item van-hairline--bottom">
        <div class="left">{{ $t("minex.account") }}</div>
        <div style="color: #666;">{{ userInfo.username }}</div>
      </div>
      <div class="item van-hairline--bottom">
        <div class="left">{{ $t("setting.real_name") }}</div>
        <div style="color: #666;">{{ userInfo.name }}</div>
      </div>
      <div class="item van-hairline--bottom">
        <div class="left">{{ $t("minex.level") }}</div>
        <div style="color: #666;">{{ userInfo.vip }}</div>
      </div>
      <div class="item van-hairline--bottom">
        <div class="left">{{ $t("q6") }}</div>
        <div style="color: #666;">{{ userInfo.xinyu }}</div>
      </div>
    </div>
    <div style="height: 10px;background-color: transparent;"></div>
    <div class="items">
      <div class="item van-hairline--bottom" @click="toInfomation()">
        <div class="left">{{ $t("setting.base_setting") }}</div>
        <van-icon name="arrow" />
      </div>
      <div class="item van-hairline--bottom" @click="toPassword(1)">
        <div class="left">{{ $t("setting.login_pwd_tip") }}</div>
        <van-icon name="arrow" />
      </div>
      <div class="item van-hairline--bottom" @click="toBank()">
        <div class="left">{{ $t("wallet.wallet_label") }}</div>
        <div class="right">
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="item van-hairline--bottom" @click="toPassword(2)">
        <div class="left">{{ $t("minex.change_pay_password") }}</div>
        <div class="right">
          <van-icon name="arrow" />
        </div>
      </div>
      <!-- <div class="item van-hairline--bottom" @click="toLanguage()">
          <div class="left">{{$t("setting.language")}}</div>
          <div class="right">
            <van-icon name="arrow" />
          </div>
        </div> -->
    </div>
    <!-- <van-button class="sign-out" type="primary" size="normal" @click="loginout()">{{$t("setting.logout")}}</van-button> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    toPassword(type) {
      this.$router.push({ path: '/SetPassword',query:{type:type} });
    },
    toPayPassword() {
      if (this.userInfo.paypassword !== this.$t("setting.no_setting")) {
        this.$toast(this.$t("withdraw.with_service"));
      } else {
        this.$router.push({ path: '/SetPayPassword' });
      }
    },
    toLoginPassword() {
      this.$router.push({ path: '/SetLoginPassword' });
    },

    toLanguage() {
      this.$router.push({
        name: 'Language',
        params: {
          "type": "setting"
        }
      });
    },
    toBank() {
      this.$router.push({ path: '/Setbank' });
    },
    toInfomation() {
      this.$router.push({ path: '/Infomation' });
    },
    loginout() {
      this.$dialog.confirm({
        message: this.$t("minex.confirm_logout"),
        className: 'noVw',
      }).then(() => {
        localStorage.clear()
        this.$router.push({ path: '/Login' });
      })
        .catch(() => {
          // on cancel
        });
    },
    toServicePage() {
      this.$router.push("ServicePage");
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (res.data.paypassword) {
            this.userInfo.paypassword = this.$t("setting.y_setting");
          } else {
            this.userInfo.paypassword = this.$t("setting.no_setting");
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container .items {
  background-color: #fff;
  font-size: 30px;
  color: #000;
  padding: 0 25px;
}

.container .items .item {
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 10px;
}

.container .items .van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.container .sign-out {
  margin: 500px 20px 0;
  height: 100px;
  line-height: 100px;
  border-radius: 50px;
  color: #fff;
  font-size: 40px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
}

.container .item .desc {
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}

.container .item .right {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
